import React from "react";
import { Navigate } from "react-router-dom";
import { AuthStatus } from "../../services/cognitoService/AuthStatus";
import { AuthContext } from "../contexts/auth/authContext";

interface RoutesContentInterface {
   isGuarded: boolean;
   redirectPath?: string;
   children: React.ReactElement;
}
const GuardedRoutes = ({
   isGuarded,
   redirectPath = "/",
   children,
}: RoutesContentInterface) => {
   const { authStatus, signOut } = React.useContext(AuthContext);

   const rollingExpiration = sessionStorage.getItem("rollingExpiration");

   if (rollingExpiration) {
      const expiration = parseInt(rollingExpiration);
      const now: number = Math.floor(Date.now() / 1000);

      if (now > expiration) {
         signOut();
      }
   }

   if (authStatus === AuthStatus.SignedIn || !isGuarded) {
      return children;
   }
   return <Navigate to={redirectPath} replace />;
};

export default GuardedRoutes;
